import { render, staticRenderFns } from "./AbaCadastrarConcurso.vue?vue&type=template&id=0b715e6f&scoped=true"
import script from "./AbaCadastrarConcurso.vue?vue&type=script&lang=ts"
export * from "./AbaCadastrarConcurso.vue?vue&type=script&lang=ts"
import style0 from "./AbaCadastrarConcurso.vue?vue&type=style&index=0&id=0b715e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b715e6f",
  null
  
)

export default component.exports